/**
 * Google SSO Provider
 * Uses Google Identity Services (GIS) OAuth2 token flow.
 * Requires: VUE_APP_GOOGLE_CLIENT_ID in .env
 *
 * Flow: custom button click → GIS popup → user grants permission → access token
 * The access token is sent to the backend, which calls Google's userinfo endpoint.
 */

function loadGisSdk() {
  if (window.google?.accounts?.oauth2) return Promise.resolve();

  return new Promise((resolve, reject) => {
    const existing = document.getElementById('gis-sdk');
    if (existing) {
      existing.addEventListener('load', resolve);
      existing.addEventListener('error', reject);
      return;
    }
    const script = document.createElement('script');
    script.id = 'gis-sdk';
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = () => reject(new Error('Failed to load Google Identity Services SDK'));
    document.head.appendChild(script);
  });
}

export async function getToken() {
  await loadGisSdk();

  const clientId = process.env.VUE_APP_GOOGLE_CLIENT_ID;
  if (!clientId) {
    throw new Error('VUE_APP_GOOGLE_CLIENT_ID is not configured');
  }

  return new Promise((resolve, reject) => {
    const client = window.google.accounts.oauth2.initTokenClient({
      client_id: clientId,
      scope: 'openid email profile',
      callback: (response) => {
        if (response.error) {
          reject(new Error(response.error_description || response.error));
        } else {
          resolve(response.access_token);
        }
      }
    });

    client.requestAccessToken();
  });
}
